import React from 'react';
import {Typography, withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ContactGrid from '../../components/Contacts/ContactGrid';
import Toolbar from '../../components/Toolbar/Toolbar';
import {get} from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import DeleteButton from '../../components/Form/DeleteButton';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TowLine from '../../components/Text/TwoLine';
import Paper from '@material-ui/core/Paper';
import FormCheck from '../../components/Form/FormCheck';
import {
    withPaginator,
    Pagination
} from '../../components/Pagination';
import FormaterDate from '../../components/Formater/Date';
import TableRowClickable from '../../components/Form/TableRowClickable';
import TableCellSortable, {xOrder} from "../../components/Form/TableCellSortable";
import SearchForm from "../../components/Contacts/SearchForm";
import Grid from "@material-ui/core/Grid";
import EllipsisWithTooltip from "../../components/Formater/EllipsisWithTooltip";

const ContractsIndex = ({classes, items: contracts, showSubs ,search}) => {

    const {column, order, filter} = search;
    const paramsQuery = (filter ? '&filter=' + filter : '');
    let searchQuery = `/contract?`;
    if (column) {
        searchQuery += '&column=' + column;
    }
    if (order) {
        searchQuery += '&order=' + order;
    }

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('contract.self')}
                subtitle={''}
                items={[
                    {
                        icon: 'add',
                        text: i18n.get('contract.add'),
                        href: `/contract/create`,
                        size: 'small',
                    },
                ]}
            />
            <SearchForm url={searchQuery} {...search} />
            <Paper className={classes.paper}>
                {contracts && contracts.length > 0 ? (
                    <Table className={classes.list}>
                        <TableHead>
                            <TableRow>
                                <TableCellSortable
                                    action={`/contract?column=contact&order=${xOrder(order)}` + paramsQuery}
                                    active={column === 'contact'}
                                    order={order}
                                >
                                    {i18n.get('contract.form.subcontractor')}
                                </TableCellSortable>
                                <TableCellSortable
                                    action={`/contract?column=building&order=${xOrder(order)}` + paramsQuery}
                                    active={column === 'building'}
                                    order={order}
                                    align={'center'}
                                >
                                    {i18n.get('contract.form.construction_project')}
                                </TableCellSortable>
                                <TableCellSortable
                                    action={`/contract?column=warranty_period_end&order=${xOrder(order)}` + paramsQuery}
                                    active={column === 'warranty_period_end'}
                                    order={order}
                                    align={'center'}
                                >
                                    {i18n.get('contract.form.warranty_period_end')}
                                </TableCellSortable>
                                <TableCell scope="col" align={'center'}>{i18n.get('invoice.actions')}</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {contracts.map( (contract, idx) => (
                                <TableRowClickable key={`contract_`+idx}>
                                    <TableCell>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                { contract.contact ? contract.contact.company_name : '' }
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    <TableCell align={'center'}>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {contract.building && contract.building.name}
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    <TableCell align={'center'}>
                                        <Typography component="h6">
                                            <EllipsisWithTooltip>
                                                {contract.warranty_period_end && (<FormaterDate value={contract.warranty_period_end} />) }
                                            </EllipsisWithTooltip>
                                        </Typography>
                                    </TableCell>
                                    <TableCell onClick={e => { e.stopPropagation('all');}} style={{cursor:'default'}} align={'center'}>
                                        {window.can('contracts.view') && (
                                            <IconButton
                                                component="a"
                                                href={`/contract/${contract.id}`}
                                            >
                                                <Icon>find_in_page</Icon>
                                            </IconButton>
                                        )}
                                        {window.can('contracts.update') && (
                                            <IconButton
                                                component="a"
                                                href={`/contract/${contract.id}/edit`}
                                            >
                                                <Icon>edit</Icon>
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRowClickable>
                            ))}
                        </TableBody>
                        <Pagination colSpan={5} classes={{spacer: "none"}}/>
                    </Table>
                ) : (
                    <Grid container>
                        <Grid>{'keine Einträge vorhanden'}</Grid>
                    </Grid>
                )}
            </Paper>
        </Layout>
    );

};


const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },

    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    },
});

export default withStyles(styles)(
    withPaginator('contracts')(ContractsIndex)
);
